import {useState} from 'react';
import {Link} from 'react-router-dom';

import './CSS/Header.css';

/**
 * ヘッダーのコンポーネントです。
 * @returns  React.FunctionComponent
 */
const Header: React.FC = () => {
    const [headerClassName, SetHeaderClassName] = useState('');
    const [headerMenuClassName, SetHeaderMenuClassName] = useState('');
    const [menuButtonClassName, SetMenuButtonClassName] = useState('');

    const OnClickMenu = () => {
        if (menuButtonClassName === '') {
            SetHeaderClassName('header-full');
            SetHeaderMenuClassName('header-menu-active');
            SetMenuButtonClassName('active');
            //DisableBodySchroll(true);
        } else {
            SetHeaderClassName('');
            SetHeaderMenuClassName('');
            SetMenuButtonClassName('');
            //DisableBodySchroll(false);
        }
    };

    return (
        <header id='header' className={headerClassName}>
            <div className='header-container'>
                <div>
                    <Link to='/'>
                        <h1 className='header-logo'>Quick IoT</h1>
                    </Link>
                </div>
                <div id='header-menu-containar'>
                    <ul id='header-menu' className={headerMenuClassName}>
                        <li className='nav-item'>
                            <Link to='/' onClick={OnClickMenu}>
                                ダッシュボード
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/privacy' onClick={OnClickMenu}>
                                プライバシーポリシー
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/contact' onClick={OnClickMenu}>
                                お問い合わせ
                            </Link>
                        </li>
                        <li className='nav-item' onClick={OnClickMenu}>
                            <Link to='/releaseNote'>リリースノート</Link>
                        </li>
                    </ul>
                    <button className={'menu-trigger ' + menuButtonClassName} id='menu-button' onClick={OnClickMenu}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                    <Link to='/logout' id='logout'>
                        <span className='material-symbols-outlined'>logout</span>
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default Header;
